import PropTypes from 'prop-types';
import { useState } from 'react';
import DashboardNoRecord from '../DashboardNoRecord/DashboardNoRecord';
import DashboardSchedulesTableRow from './DashboardSchedulesTableRow';
import ManageScheduleModal from './ManageScheduleModal/ManageScheduleModal';

function DashboardSchedulesTable({ schedules, refetch }) {
  const [activeSchedule, setActiveSchedule] = useState(null);
  const [open, setOpen] = useState(false);

  function handleOpenModal(p) {
    setActiveSchedule(p);
    setOpen(true);
  }

  function handleCloseModal() {
    setOpen(false);
    setActiveSchedule(null);

    refetch();
  }

  return (
    <>
      <div className="mt-4 rounded-lg border border-rcgray-200 bg-rcgray-50/50 p-4 shadow-md">
        <table className="min-w-full divide-y divide-gray-300">
          <thead>
            <tr>
              <th
                scope="col"
                className="py-3.5 pr-3 pl-4 text-left font-semibold text-gray-900 text-sm sm:pl-0"
              >
                Who&apos;s it for?
              </th>
              <th
                scope="col"
                className="hidden px-3 py-3.5 text-left font-semibold text-gray-900 text-sm sm:table-cell"
              >
                When&apos;s it being made?
              </th>

              <th scope="col" className="py-3.5 pr-4 pl-3 sm:pr-0">
                <span className="sr-only">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {schedules.length > 0 ? (
              schedules.map((schedule) => (
                <DashboardSchedulesTableRow
                  key={schedule.id}
                  schedule={schedule}
                  handleOpenModal={handleOpenModal}
                />
              ))
            ) : (
              <tr>
                <td colSpan={3} className="py-4">
                  <DashboardNoRecord text="Sorry, you don't have any upcoming scheduled retainers." />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ManageScheduleModal
        open={open}
        handleCloseModal={handleCloseModal}
        activeSchedule={activeSchedule}
        refetch={refetch}
      />
    </>
  );
}

DashboardSchedulesTable.propTypes = {
  schedules: PropTypes.array.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default DashboardSchedulesTable;
